import React from 'react';
import { getChildrenToRender, isImg } from './utils';

class Banner11 extends React.PureComponent {
  render() {
    // 配置文件返回
    const { ...props } = this.props;
    const { dataSource } = props;
    delete props.dataSource;
    delete props.isMobile;
    return (
      <div {...dataSource.OverPack} {...props}>
        <div {...dataSource.bg}>
          <img src={dataSource.bg.children} width="100%" alt="img" />
        </div>
        <div {...dataSource.titleWrapper}>
          {dataSource.titleWrapper.children.map(getChildrenToRender)}
        </div>
      </div>
    );
  }
}

export default Banner11;
